// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

// 引入 Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/global.css'
import '../static/css/my_style.css'
import 'element-ui/lib/theme-chalk/display.css';
import '../static/iconfont/iconfont.css' /*引入字体图标*/

// 使用 Element UI
Vue.use(ElementUI);


// 富文本样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import remConfig from './util/rem';


import CKEditor from '@ckeditor/ckeditor5-vue2';


Vue.use( CKEditor );

import adminApi from './util/common.js';
import vue_resource from 'vue-resource';
Vue.use(vue_resource);
remConfig();


// 路由守卫
router.beforeEach((to, from, next) => {
    if (to.path === '/Login') {
        next()
        return
    }
    // 获取token
    const token = sessionStorage.getItem('access-token')
    // 判断token的状态,取反则没有token，让用户去登录
    if (!token) {
        // 避免重复重定向到登录页
        if (from.path === '/Login') {
            next(false) // 中止导航
        } else {
            next('/Login')
        }
        return
    }
    next()
})

// 捕获路由重定向错误（Vue Router 3.1+ 的兼容处理）
const originalPush = router.push
const originalReplace = router.replace

router.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
            return Promise.reject(err)
        }
    })
}

router.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
            return Promise.reject(err)
        }
    })
}

// 全局捕获路由错误，避免控制台警告
router.onError((error) => {
    const pattern = /Redirected when going from/
    const isRedirectedError = pattern.test(error.message)
    if (!isRedirectedError) {
        console.error(error)
    }
})

//定义全局变量
Vue.prototype.adminApi = adminApi;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js